import skillsJson from './skills.json'

// slug → sub-skills, ingested from the skills spreadsheet (see
// scripts/ingest-skills.mjs). Regenerate by re-running that script.
const skillsBySlug: Record<string, string[]> = skillsJson

// Classes excluded from the experiment even though they have skills data —
// e.g. no trailer and no sample video, so the story screens would render an
// empty video slot. Keep the reason with each entry.
const EXCLUDED_SLUGS = new Set<string>([
  'judd-apatow-teaches-comedy', // no trailer and no sample
])

/** Sub-skills for a class slug, or [] when the slug has none. */
export const getSkills = (slug: string | undefined): string[] =>
  (slug && skillsBySlug[slug]) || []

/**
 * The modal is eligible on any class that has ingested skills data and is not
 * explicitly excluded.
 */
export const isEligibleSlug = (slug: string | undefined): slug is string =>
  !!slug && slug in skillsBySlug && !EXCLUDED_SLUGS.has(slug)
